import "./DefaultPage.css"; 

export default function DefaultPage() {
  return (
    <div className="default-container">
      <div className="default-box">
        <h1>Welcome to Member Sign-Ups</h1>
        <p>Please use your store QR code to continue.</p>
      </div>
    </div>
  );
}
